import React,{useEffect,useState} from 'react'
import TextField from '../../components/TextField'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useCreateBranch} from '../../hooks/branches/useCreate'


const CreateBranch = () => {
    // STATES
    // PAYLOAD STATE
    const [state,setState]=useState({
        branchCode:0,
        branchName:""
    })
    // MISC STATE
    const [error,setError]=useState("")
    const [success,setSuccess]=useState("")

    // MUTATION
    const {mutate:createBranch,error:createError,isLoading,isSuccess}=useCreateBranch(state)
    
    // HANDLERS
    // INPUT HANDLER
    const handleChange=({target:{name,value}})=>{
            setState({...state,[name]:value})
    }

    // SUBMIT HANDLER
    const handleSubmit=(e)=>{
        e.preventDefault();
        // REFRESH ERROR
        setError('')
        if(state.branchCode==0||state.branchCode.toString().length!=3){ setError("Please enter a valid branch code"); return}
        createBranch()
    }

    // EFFECTS
    useEffect(()=>{
        if(isSuccess){
            setSuccess("Branch created successfully")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    },[isSuccess])

    useEffect(()=>{
        if(createError){
            const message=createError?.response?.data?.message
            setError(message)
        }
    },[createError])
    return (
        <form className='w-full flex flex-col space-y-5' onSubmit={handleSubmit}>
            {success.length>0&&<Success>{success}</Success>}
            {error.length>0&&<Error>{error}</Error>}
            <TextField label='Branch Code' required name='branchCode' type={"number"} value={state.branchCode} onChange={handleChange} />
            <TextField label='Branch Name' required name='branchName' value={state.branchName} onChange={handleChange}/>
            <SubmitButton loading={isLoading}>Submit</SubmitButton>
        </form>
    )
}

export default CreateBranch
